import Layout from '@/layout';
var statisticsRouter = {
  path: '/statistics',
  component: Layout,
  redirect: '/statistics/financial-details',
  name: 'statistics',
  alwaysShow: true,
  meta: {
    title: '交易明细',
    icon: 'clipboard'
  },
  children: [{
    path: 'financial-details',
    component: function component(resolve) {
      return require(['@/views/my-create/financial-management/financial-details/index.vue'], resolve);
    },
    name: 'financial-details',
    meta: {
      title: '财务管理-交易明细',
      icon: ''
    }
  }, {
    path: 'sales',
    component: function component() {
      return import('@/views/my-create/sales-statistics/index');
    },
    name: 'sales',
    meta: {
      title: '销售统计',
      icon: ''
    }
  }, {
    path: 'sales-after',
    component: function component() {
      return import('@/views/my-create/sales-after/index');
    },
    name: 'sales-after',
    meta: {
      title: '售后服务',
      icon: ''
    }
  }]
};
export default statisticsRouter;